import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslate } from '@tolgee/react';

const EndConferenceConfirmationChild = ({
  open,
  setOpen,
  onConfirm,
}) => {
  const { t } = useTranslate();

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="end-conference-dialog-title"
      aria-describedby="end-conference-dialog-description"
    >
      <DialogTitle id="end-conference-dialog-title">
        {t('general.warning')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="end-conference-dialog-description">
          {t('conferences.end_conference_confirm')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('general.no')}</Button>
        <Button style={{ color: "red" }} onClick={handleConfirm} autoFocus>
          {t('conferences.end_conference')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EndConferenceConfirmationChild;
